<div
  class="escala"
  [sgtTooltip]="escala.nome"
  *ngIf="escala">
  <div
    class="escala__container"
    [ngClass]="{
      'escala--critico': escala.escalaId === EnumEscala.CRITICO,
      'escala--atencao': escala.escalaId === EnumEscala.ATENCAO,
      'escala--razoavel': escala.escalaId === EnumEscala.RAZOAVEL,
      'escala--saudavel': escala.escalaId === EnumEscala.SAUDAVEL,
      'escala--ideal': escala.escalaId === EnumEscala.IDEAL,
      'escala__container--with-text': showText
    }"
  >
    <span class="escala__badge">
      <span class="escala__badge-text" *ngIf="showText">{{ escala.nome }}</span>
      <span class="escala__badge-symbol" *ngIf="showSymbol">{{ escala.simbolo }}</span>
    </span>
  </div>
</div>
